import { render } from "./AttendanceBoard.vue?vue&type=template&id=fc08fec2&scoped=true"
import script from "./AttendanceBoard.vue?vue&type=script&lang=js"
export * from "./AttendanceBoard.vue?vue&type=script&lang=js"

import "./AttendanceBoard.vue?vue&type=style&index=0&id=fc08fec2&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc08fec2"]])

export default __exports__